module.exports = __webpack_public_path__ + "public/img/advisor_case_study.44ebd92.jpeg";